import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  pagination: {
    display: "flex",
    justifyContent: "end",
  },
}));
